import {createRouter, createWebHistory} from 'vue-router';
import middlewarePipeline from './middlewarePipeline';
// import routes from './uiRoutes';
// import appRoutes from './routes';
import commonRoutes from './common';
import brandRoutes from './brand';


const router = createRouter({
  history: createWebHistory(),
  routes: [...commonRoutes, ...brandRoutes],
  scrollBehavior () {
    return { left: 0, top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

  const context = {
    to,
    from,
    next,
    router,
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })

})


export default router;
